const HIDDEN = /(^|\/)(\.|__MACOSX|Thumbs\.db$|desktop\.ini$)/i;

export const keepFile = (f) => !HIDDEN.test(f.webkitRelativePath || f.name) && f.size > 0;

const named = (file, path) => (path && path !== file.name ? new File([file], path, { type: file.type, lastModified: file.lastModified }) : file);

async function walk(entry, path = "") {
  if (entry.isFile) {
    const file = await new Promise((res, rej) => entry.file(res, rej));
    return [named(file, `${path}${file.name}`)];
  }
  const reader = entry.createReader();
  const out = [];
  let batch;
  do {
    batch = await new Promise((res, rej) => reader.readEntries(res, rej));
    for (const e of batch) out.push(...(await walk(e, `${path}${entry.name}/`)));
  } while (batch.length);
  return out;
}

export async function droppedFiles(e) {
  const items = Array.from(e.dataTransfer?.items || []);
  const entries = items.map((i) => i.webkitGetAsEntry?.()).filter(Boolean);
  if (!entries.length) return Array.from(e.dataTransfer?.files || []).filter(keepFile);
  const all = [];
  for (const en of entries) all.push(...(await walk(en)));
  return all.filter(keepFile);
}

export const pickedFiles = (e) => Array.from(e.target.files || []).filter(keepFile).map((f) => named(f, f.webkitRelativePath));
